module.exports = require("./tr-CY");